import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  type CanActivate,
  type CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AuthenticationService } from '../../core/auth/authentication.service';
import { Observable } from 'rxjs';
import { AppInitService } from '../../core/services/app-init.service';

@Injectable({
  providedIn: 'root'
})
export class VigilantSessionsGuard implements CanActivate, CanActivateChild {
  private cookieService = inject(CookieService);
  private router = inject(Router);
  private appInitService = inject(AppInitService);
  private authService = inject(AuthenticationService);

  redirect(verify: boolean) {
    if (!verify) {
      this.router.navigate(['/login']);
    }
  }

  canActivate(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _route: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Prefer AuthenticationService unified token retrieval
    const token = this.authService.getToken();
    if (token) {
      return true;
    }

    // Fallback to cookie presence check
    if (this.cookieService.check('token')) {
      return true;
    }

    // If no token, try to restore the session
    return new Observable(observer => {
      this.appInitService
        .handlePageReload()
        .then(success => {
          if (success) {
            observer.next(true);
          } else {
            this.redirect(false);
            observer.next(false);
          }
          observer.complete();
        })
        .catch(() => {
          this.redirect(false);
          observer.next(false);
          observer.complete();
        });
    });
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(route, state);
  }
}
